'use client';

import {
  CaseStudyBody,
  CaseStudyResultsTable,
} from '@/components/case-study/case-study-body';
import { CaseStudyHero } from '@/components/case-study/case-study-hero';
import { CaseStudyQuote } from '@/components/case-study/case-study-quote';
import { CustomerVideos } from '@/components/sections/customer-videos';
import Testimonials from '@/components/sections/testimonials';
import { useTranslation } from '@/lib/i18n/context';

const DeOnlineDrogistCaseStudy = () => {
  const { t, isRTL } = useTranslation();
  return (
    <>
      <CaseStudyHero
        customerName="De Online Drogist"
        title={t.customerStories['deonlinedrogist_hero_title']}
        subtitle={t.customerStories['deonlinedrogist_what_we_did']}
        stats={[
          {
            value: isRTL ? '٧٣٪' : '73%',
            label: t.customerStories['Automation rate'],
          },
          {
            value: isRTL ? '+٢٥' : '25+',
            label: t.customerStories['Complex actions'],
          },
          {
            value: isRTL ? '+٤٠ ألف' : '40K+',
            label: t.customerStories['Products'],
          },
        ]}
      />

      <CaseStudyBody
        aside={{
          logoSrc: '/logos/logo-deonlinedrogist.svg',
          logoAlt: 'De Online Drogist',
          company: t.customerStories['deonlinedrogist_company_description'],
          industry: t.customerStories['E-commerce / Healthcare'],
          websiteUrl: 'https://www.deonlinedrogist.nl',
          keyResults: [
            t.customerStories['• 73% automation rate'],
            t.customerStories['• 25+ complex actions'],
            t.customerStories['• End-to-end commerce'],
            t.customerStories['• 24/7 multilingual support'],
          ],
        }}
      >
        <p>{t.customerStories['deonlinedrogist_intro']}</p>

        <h2>{t.customerStories['deonlinedrogist_challenge_title']}</h2>
        <p>{t.customerStories['deonlinedrogist_challenge_p1']}</p>
        <p>{t.customerStories['deonlinedrogist_challenge_p2']}</p>

        <h2>{t.customerStories['deonlinedrogist_solution_title']}</h2>
        <p>{t.customerStories['deonlinedrogist_solution_p1']}</p>
        <p>{t.customerStories['deonlinedrogist_solution_p2']}</p>
        <p>{t.customerStories['deonlinedrogist_solution_p3']}</p>

        <h2>{t.customerStories['deonlinedrogist_actions_title']}</h2>
        <p>{t.customerStories['deonlinedrogist_actions_intro']}</p>
        <ul>
          <li>
            <strong>{t.customerStories['Order Management']}</strong>{' '}
            {t.customerStories['deonlinedrogist_action_orders']}
          </li>
          <li>
            <strong>{t.customerStories['Product Expertise']}</strong>{' '}
            {t.customerStories['deonlinedrogist_action_products']}
          </li>
          <li>
            <strong>{t.customerStories['Returns & Refunds']}</strong>{' '}
            {t.customerStories['deonlinedrogist_action_returns']}
          </li>
          <li>
            <strong>{t.customerStories['Multilingual Support']}</strong>{' '}
            {t.customerStories['deonlinedrogist_action_multilingual']}
          </li>
        </ul>

        <CaseStudyQuote
          quote={[
            t.customerStories['deonlinedrogist_quote_p1'],
            t.customerStories['deonlinedrogist_quote_p2'],
            t.customerStories['deonlinedrogist_quote_p3'],
          ]}
          attribution={t.customerStories['deonlinedrogist_quote_attribution']}
        />

        <h3>{t.customerStories['The Results']}</h3>
        <p>{t.customerStories['deonlinedrogist_results_intro']}</p>

        <CaseStudyResultsTable
          metricLabel={t.customerStories['Metric']}
          impactLabel={t.customerStories['Impact']}
          rows={[
            {
              metric: t.customerStories['Automation rate'],
              impact: isRTL ? '٧٣٪' : '73%',
            },
            {
              metric: t.customerStories['Complex actions'],
              impact: isRTL ? '+٢٥' : '25+',
            },
            {
              metric: t.customerStories['Products in catalog'],
              impact: t.customerStories['40,000+ items covered'],
            },
            {
              metric: t.customerStories['Coverage'],
              impact: t.customerStories['24/7 multilingual'],
            },
          ]}
        />

        <h2>{t.customerStories['deonlinedrogist_impact_title']}</h2>
        <p>{t.customerStories['deonlinedrogist_impact_p1']}</p>
        <p>{t.customerStories['deonlinedrogist_impact_p2']}</p>
        <p>{t.customerStories['deonlinedrogist_impact_p3']}</p>
      </CaseStudyBody>

      <CustomerVideos />

      <Testimonials />
    </>
  );
};

export default DeOnlineDrogistCaseStudy;
